import { apiCall, baseUrl, exportFileCall } from './config';
import { shouldUseMock } from '../../utils/common';
import { sessionResultGetMock, sessionUsersGetMock, successMock } from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { activitySessionPath } from '../../utils/paths';

export default {
  sessionUsersGet: ({ session_id, activity_id, filters }) => {
    if (shouldUseMock()) {
      return sessionUsersGetMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${session_id}/activity/${activity_id}/user/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  usersAttendanceSet: ({ session_id, activity_id, body }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${session_id}/activity/${activity_id}/completed`,
      'POST',
      body
    );
  },
  quizAttemptsSet: ({ session_id, body }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${session_id}/quiz/tentatives`,
      'POST',
      body
    );
  },
  quizVisibilitySet: ({ session_id, body }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${session_id}/quiz/visibility`,
      'POST',
      body
    );
  },
  getSessionResult: (id, filters) => {
    if (shouldUseMock()) {
      return sessionResultGetMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${id}/user/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  sessionResultExport: (sessionId) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${activitySessionPath}session/${sessionId}/user/list/download`,
      method: 'GET',
      filename: `session_${sessionId}_result.csv`,
    });
  },
};
